import React from 'react'
import FundCard from './FundCard'

function PastCampaigns() {
  return (
    <div><FundCard /></div>
  )
}

export default PastCampaigns